import clsx from "clsx";
import * as React from "react";
import { ButtonProps } from ".";

function Button({
    loading,
    error,
    success,
    fullWidth,
    className,
    disabled,
    ...props
}: ButtonProps) {
    return (
        <button
            className={clsx(className, "tmp-btn", {
                "tmp-btn__full-width": fullWidth,
                "tmp-input-error": error,
            })}
            disabled={disabled || loading}
            {...props}
        >
            {loading && <i className="fas fa-spinner fa-pulse" />}
            {error && <i className="fas fa-times" />}
            {success && <i className="fas fa-check" />}
            {props.children}
        </button>
    );
}

export default Button;
